
import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Info } from "lucide-react";

interface MessageDialogProps {
    message: string;
    trigger?: React.ReactNode;
}

export const MessageDialog = ({ message, trigger }: MessageDialogProps) => {
    return (
        <Dialog>
            <DialogTrigger asChild>
                {trigger || (
                    <Button variant="ghost" size="icon" className="h-6 w-6 ml-1">
                        <Info className="h-4 w-4 text-muted-foreground" />
                    </Button>
                )}
            </DialogTrigger>
            <DialogContent className="max-w-[600px] max-h-[80vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>Details</DialogTitle>
                </DialogHeader>
                <div className="mt-4 p-4 bg-muted/50 rounded-lg whitespace-pre-wrap text-sm leading-relaxed">
                    {message}
                </div>
            </DialogContent>
        </Dialog>
    );
};
